import React from "react";
import { Link } from "react-router-dom";

const image1 = "/images/editorial/story.jpg";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16">
        <div className="label-xs mb-4">About</div>
        <h1 className="font-display text-5xl md:text-7xl font-medium leading-[0.95]">
          Quiet clothes for<br />everyday life.
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="aspect-[16/9] md:aspect-[21/9] overflow-hidden">
          <img src={image1} alt="Simple Style Mode studio" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28 space-y-8 text-lg leading-relaxed text-neutral-700">
        <p>
          Simple Style Mode creates minimalist clothing designed for everyday
          wear. Our focus is on quality basics, clean design, and timeless
          style.
        </p>
        <p>
          We started Simple Style Mode because we were tired of logos,
          seasonal trends, and fast-fashion waste. We wanted a wardrobe made of
          quiet pieces — a good t-shirt, a hoodie that gets better with age, a
          pair of jeans that fits right every time.
        </p>
        <p>
          Every garment is designed in-house and produced in small batches
          using considered fabrics: organic cottons, heavyweight fleeces,
          ring-spun denims. Every product is unbranded or sold under our own
          brand. No third-party logos, no licensed collaborations, no replicas
          — just honest, wearable essentials.
        </p>
        <p>
          Simple Style Mode is operated by <strong>ULTRANEQ LLC</strong>,
          based in Albuquerque, New Mexico, and ships worldwide directly from
          our warehouse.
        </p>

        <div className="pt-8 border-t border-[color:var(--ssm-border)] grid grid-cols-1 sm:grid-cols-3 gap-8 text-sm">
          <div>
            <div className="label-xs mb-2">Designed</div>
            <div>In-house, Albuquerque</div>
          </div>
          <div>
            <div className="label-xs mb-2">Produced</div>
            <div>Small batches</div>
          </div>
          <div>
            <div className="label-xs mb-2">Shipped</div>
            <div>Worldwide</div>
          </div>
        </div>

        <div className="pt-8">
          <Link
            to="/shop"
            data-testid="about-shop-btn"
            className="inline-flex items-center gap-3 px-8 py-4 bg-black text-white text-xs uppercase tracking-[0.25em] hover:bg-neutral-800 transition-colors"
          >
            Shop the collection
          </Link>
        </div>
      </section>
    </div>
  );
}
